import {formatBalance} from "../utils";
import {Button} from "../components/Button";
import {RoundedModal} from "../components/Modal";
import React, {Fragment, useEffect} from "react";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import closePurple from "../assets/icons/modal/close-purple@2x.png";
import {useDispatch, useSelector} from "react-redux";
import UIState from "../store/uiState";
import tokenIcon from "../assets/logos/grove@2x.png";
import tfuelIcon from "../assets/logos/tfuel@2x.png";
import purpleDownIcon from "../assets/icons/arrows/purple-down@2x.png";
import Wallet, {selectTfuelGrovePair} from "../store/models/wallet";
import {ContractAddresses, ThetaSwap} from "../constants";
import {ethers} from "ethers";
import _ from "lodash";
import Loader from "../components/Loader";

export const GetMoreGroveModal = ({defaultAmount}) => {
    const pair = useSelector(selectTfuelGrovePair);
    const groveAddress = ContractAddresses.GroveToken;
    const [amount, setAmount] = React.useState(_.isNil(defaultAmount) ? '' : `${defaultAmount}`);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(true);
    const amountOutput = _.isNaN(amount) ? '0' : "" + amount;
    const swapData = Wallet.helpers.getSwapData(ThetaSwap.WTFUEL.address, groveAddress, '', amountOutput, pair);
    const {amountLimit} = swapData || {};
    const amountLimitBN = ethers.utils.parseEther(_.isNaN(amountLimit) ? '0' : "" + amountLimit);
    const isAmountEmpty = (_.isNaN(amountLimit) || _.isEmpty(amount) || amount === '0');
    console.log('amountLimit == ', amountLimit)
    console.log('amountLimitBN == ', amountLimitBN.toString())

    console.log('amount == ', amount)
    console.log(swapData);

    const onClose = () => {
        dispatch(UIState.actions.hideModal());
    }

    const loadPair = async () => {
        const done = await dispatch(Wallet.actions.fetchTfuelGrovePair());
        setIsLoading(false);
    }

    const onSwap = async () => {
        const done = await dispatch(Wallet.actions.swapTfuelForGrove(amountLimit, amountOutput));
    }

    useEffect(() => {
        loadPair();
    }, []);

    return (
        <RoundedModal title={'NEED MORE $GROVE?'}
                      header={<div>
                          <a onClick={onClose}
                             className={'GetMoreGroveModal__close'}
                          >
                              <img src={closePurple}/>
                          </a>
                      </div>}
                      className={'GetMoreGroveModal'}
        >
            <div className={'GetMoreGroveModal__title'}>
                Get More GROVE
            </div>
            <div className={'GetMoreGroveModal__subtitle'}>
                Use your TFUEL to convert to $GROVE
            </div>
            {
                isLoading &&
                <div className={'GetMoreGroveModal__loading-content'}>
                    <Loader size={'medium'}/>
                    <div className={'GetMoreGroveModal__loading-title'}>
                        Fetching data...
                    </div>
                </div>
            }
            {
                !isLoading &&
                <Fragment>
                    <div className={'GetMoreGroveModal__tfuel-card'}
                         style={isAmountEmpty ? {opacity: 0.5} : {}}
                    >
                        <img src={tfuelIcon}
                             style={isAmountEmpty ? {marginRight: 0} : {}}
                        />
                        <span>
                            {isAmountEmpty ? '' : `${formatBalance(amountLimitBN)} TFUEL`}
                        </span>
                    </div>
                    <img src={purpleDownIcon}
                         style={isAmountEmpty ? {opacity: 0.5} : {}}
                         className={'GetMoreGroveModal__down-icon'}
                    />
                    <div className={'InputWrapper'}>
                        <img src={tokenIcon}/>
                        <input
                            type="number"
                            min={0}
                            max={20000}
                            placeholder="ENTER AMOUNT"
                            value={amount}
                            autoFocus={true}
                            onChange={(e) => {
                                const value = e.target.value;
                                console.log('e.target.value == ', value);
                                // Only update state if the value is a valid number or empty
                                if (value === '' || !isNaN(value)) {
                                    setAmount(value);
                                }
                            }}
                        />
                    </div>
                    {/*<div className={'InputWrapper'}>*/}
                    {/*    <img src={tfuelIcon}/>*/}
                    {/*    <input type={'number'}*/}
                    {/*           placeholder={''}*/}
                    {/*           min={0}*/}
                    {/*           disabled*/}
                    {/*           value={(amountOutput === '' || amountOutput === '0') ? '0' : formatBalance(amountLimitBN)}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <Button size={'large'}
                            color={'red'}
                            onClick={onSwap}
                    >
                        SWAP
                    </Button>
                </Fragment>
            }

        </RoundedModal>
    )
}

export default GetMoreGroveModal;